/**
 * JoinARJoinPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait JoinARJoinPage
 */

import { useJoinARJoinPageLogic } from '@/hooks/traits/useJoinARJoinPageLogic';
import type { JoinARJoinPageConfig } from '@/hooks/traits/useJoinARJoinPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { JoinARJoinView as JoinARJoinViewEntity } from '@app/shared';
import { JoinARJoinFooterView } from '@/components/traits/JoinARJoinFooterView';
import { Stack } from '@almadar/ui/components';
import { AnimatedReveal } from '@almadar/ui/components';
import { Box } from '@almadar/ui/components';
import { JoinARJoinHeroView } from '@/components/traits/JoinARJoinHeroView';
import { JoinARJoinHeaderView } from '@/components/traits/JoinARJoinHeaderView';
import { Container } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { JoinARJoinWeekDemoView } from '@/components/traits/JoinARJoinWeekDemoView';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface JoinARJoinPageViewProps {
  config?: Partial<JoinARJoinPageConfig>;
}

export function JoinARJoinPageView({ config: propsConfig }: JoinARJoinPageViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useJoinARJoinPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['JoinARJoinView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="JoinAR" trait="JoinARJoinPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="JoinARJoinPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><JoinARJoinHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><JoinARJoinHeroView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box bg="transparent" fullWidth={true} className="py-16 md:py-24"><AnimatedReveal animation="fade-up" trigger="scroll" threshold={0.15}><Container maxWidth="xl" size="xl" padding="lg"><Stack direction="vertical" gap="xl"><Stack gap="sm" direction="vertical" align="center"><Typography content={renderPatternValue(__t("std-almadar-join:week.title"))} align="center" variant="h2" weight="bold" /><Typography variant="large" color="muted" content={renderPatternValue(__t("std-almadar-join:week.body"))} align="center" /></Stack><JoinARJoinWeekDemoView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack></Container></AnimatedReveal></Box><JoinARJoinFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default JoinARJoinPageView;
